import { Fragment } from 'react';

import { Analytics, OpenGraph, TwitterCards } from '@components/atoms';
import { PrivacyPolicyPageContent } from '@components/organisms';

const title = 'Privacy Policy | Green Line Logistics';
const description =
  'Learn how Green Line Logistics collects, uses, protects, stores, and shares information through its website, platform, and services.';
const url = 'https://greenlinelog.com/privacy-policy';

function PrivacyPolicyPage() {
  return (
    <Fragment>
      <Analytics pageTitle={title}>
        <meta name="description" content={description} />

        <OpenGraph title={title} description={description} url={url} />
        <TwitterCards title={title} description={description} site={url} />
      </Analytics>

      <PrivacyPolicyPageContent />
    </Fragment>
  );
}

export default PrivacyPolicyPage;
